import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export type Profile = {
  id: string
  first_name: string | null
  last_name: string | null
  email: string | null
  phone: string | null
  company: string | null
  bio: string | null
  website: string | null
  location: string | null
  timezone: string | null
  avatar_url: string | null
  is_admin: boolean
  created_at: string
  updated_at: string
}

export type UserPreferences = {
  id: string
  email_notifications: boolean
  push_notifications: boolean
  marketing_emails: boolean
  weekly_reports: boolean
  language: string
  theme: string
  created_at: string
  updated_at: string
}

export type Project = {
  id: string
  user_id: string
  title: string
  type: string
  content: any
  status: string
  word_count: number
  created_at: string
  updated_at: string
}